// VideoPlayer class for managing all player functionality
export class VideoPlayer {
  constructor(config) {
    this.config = config;
    this.video = null;
    this.controller = null;
  }

  initialize() {
    this.video = document.querySelector('bunny-stream-video') ||
      document.querySelector('video');
    this.controller = document.querySelector('media-controller');

    if (!this.video || !this.controller) {
      console.error('Required video or media-controller elements not found');
      return;
    }

    // Apply initial configurations
    this.applyInitialConfigurations();

    // Setup all features
    this.setupRememberPosition();
    this.setupiOS();

    this.video.addEventListener('loadeddata', () => {
      // Get the actual video element from the bunny-stream-video component
      const actualVideo = this.video.querySelector('video') ||
        this.video.shadowRoot?.querySelector('video');
      if (actualVideo) {
        if (!actualVideo.on) {
          actualVideo.on = (event, callback) => {
            actualVideo.addEventListener(event, callback);
          };
        }
        if (!actualVideo.off) {
          actualVideo.off = (event, callback) => {
            actualVideo.removeEventListener(event, callback);
          };
        }
        if (!actualVideo.trigger) {
          actualVideo.trigger = (event, data) => {
            actualVideo.dispatchEvent(new CustomEvent(event, { detail: data }));
          };
        }
      }
      const pjs = new BunnyPlayerJs(actualVideo || this.video);
      pjs.init();
    });
  }

  applyInitialConfigurations() {
    // Apply configurations that need to be set immediately
    if (this.config.config.disableIosPlayer) {
      this.video.setAttribute('webkit-playsinline', '');
    }
  }

  setupRememberPosition() {
    const rememberPos = this.config.config.rememberPosition !== null
      ? this.config.config.rememberPosition
      : this.config.videoData.rememberPlayerPosition;
    if (rememberPos) {
      const positionKey =
        `bunny_player_position_${this.config.videoData.video.guid}`;
      const lastPosition = localStorage.getItem(positionKey);
      if (lastPosition) {
        this.video.currentTime = parseFloat(lastPosition);
      }

      this.video.addEventListener('timeupdate', () => {
        localStorage.setItem(positionKey, this.video.currentTime.toString());
      });

      this.video.addEventListener('ended', () => {
        localStorage.removeItem(positionKey);
      });
    }
  }

  setupiOS() {
    if (this.config.config.disableIosPlayer) {
      this.video.setAttribute('webkit-playsinline', '');
    }
  }
}
